<template>
    <!-- 删除 -->
    <div class="">
      <v-dialog
        class="del"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.delete"
      >
        <v-form ref="form">
          <v-form-item label="产品型号" >
            {{model}}
          </v-form-item>
          <v-form-item label="软件版本" >
            {{software_version}}
          </v-form-item>
          <v-form-item label="删除类型" >
            <v-radio class="options" v-model="del_type" name="deleteType" :options="deleteTypeOptions"></v-radio>
          </v-form-item>
        </v-form>
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    UseId:{
    },
    model:{
      type:String,
      default:""
    },
    software_version:{
      type:String,
      default:""
    }
    },
    data() {
      return {
        delete:"删除",

        dialogTitle: "删除",
        del_type: "DEL_RECORD",
        isShow:false,
        deleteTypeOptions:[
          {
            label:'删除记录',
            value:"DEL_RECORD"
          },
          {
            label:'删除记录和镜像',
            value:"DEL_IMAGE"
          },
        ],
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      handleConfirm() {
      this.$delete(`/td/td-iot-api/iot/firmware/v1/${this.UseId}`,{"del_type":this.del_type}).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
      this.$emit('getData')
      this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
